import './ListLeaderboard.css';

export interface LeaderboardStat {
  label: string;
  value: string;
  accent?: string;
}

export interface LeaderboardEntry {
  id: number;
  name: string;
  /** Ranks the board and scales the bar (funded units). */
  rank: number;
  /** Tie-break for equal ranks (funded amount). */
  tieBreak: number;
  stats: LeaderboardStat[];
}

/**
 * Top-5 strip shown above the funder / rep / lead source list grids
 * (REG-658; card layout REG-661). Purely presentational: callers pass the
 * already-filtered entries (e.g. the list's active-status filter) and each
 * entity's stats.
 */
export function ListLeaderboard({ title, subtitle, entries, onOpen, emptyMessage }: {
  title: string;
  subtitle: string;
  entries: LeaderboardEntry[];
  onOpen?: (id: number) => void;
  emptyMessage?: string;
}) {
  const top = entries
    .filter((entry) => entry.rank > 0)
    .sort((a, b) => b.rank - a.rank || b.tieBreak - a.tieBreak)
    .slice(0, 5);
  const peak = Math.max(...top.map((entry) => entry.rank), 1);
  return (
    <section className="rep-data-card list-leaderboard">
      <div className="rep-card-title"><b>{title}</b><span>{subtitle}</span></div>
      {top.length === 0 ? (
        <div className="rep-top-funders-empty">{emptyMessage ?? 'No funded deals yet.'}</div>
      ) : (
        <div className="list-leaderboard-rows">
          {top.map((entry, index) => (
            <button
              key={entry.id}
              type="button"
              className="list-leaderboard-row"
              onClick={onOpen ? () => onOpen(entry.id) : undefined}
              title={entry.name}
            >
              <div className="list-leaderboard-head">
                <i>{index + 1}</i>
                <b>{entry.name}</b>
              </div>
              <div className="rep-top-funder-track"><span style={{ width: `${(entry.rank / peak) * 100}%` }} /></div>
              <div className="list-leaderboard-stats">
                {entry.stats.map((stat) => (
                  <em key={stat.label}>
                    <small>{stat.label}</small>
                    <b style={stat.accent ? { color: stat.accent } : undefined}>{stat.value}</b>
                  </em>
                ))}
              </div>
            </button>
          ))}
        </div>
      )}
    </section>
  );
}
